var map = {
	"./Art.png": 2231,
	"./Astronnaut.png": 2232,
	"./Chemistry.png": 2233,
	"./Classical.png": 2234,
	"./Coding.png": 2235,
	"./Fruit.png": 2236,
	"./Gold.png": 2237,
	"./History Books.png": 2238,
	"./Literature.png": 2239,
	"./Math.png": 2240,
	"./Money.png": 2241,
	"./Ocean.png": 2242,
	"./Space.png": 2243,
	"./Sunset.png": 2244,
	"./Trees.png": 2245,
	"./USA.png": 2246
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2230;


//////////////////
// WEBPACK FOOTER
// ./static/banners nonrecursive ^\.\/.*$
// module id = 2230
// module chunks = 61